var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeStr === '00:00:00')?_c('span',[_vm._v("待开播")]):_c('span',[_vm._v(" "+_vm._s(_vm.timeStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }